import {
    apiRequest,
    employeeWFHCreate,
    employeeWFHCheckDate,
    employeeWFHCheckNumber,
    getMaxDate
} from "../../../../../services/adapters/kepegawaian/employeeWFHService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", employeeWFHCreate, {
            body: query
        }, true)
    }

    fetchCheckDate = async (query) => {
        return await apiRequest("post", employeeWFHCheckDate, {
            body: query
        }, true)
    }

    fetchCheckNumber = async (query) => {
        return await apiRequest("post", employeeWFHCheckNumber, {
            body: query
        }, true)
    }

    fetchMaxDate = async (query) => {
        return await apiRequest("get", getMaxDate, {
            params: query
        }, true)
    }
}

export default CreateRepository